export default __webpack_public_path__ + "static/media/plus-icon.a3d42b83.svg";